import { render, staticRenderFns } from "./Garage.vue?vue&type=template&id=c330a386&scoped=true"
import script from "./Garage.vue?vue&type=script&lang=ts"
export * from "./Garage.vue?vue&type=script&lang=ts"
import style0 from "./Garage.vue?vue&type=style&index=0&id=c330a386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c330a386",
  null
  
)

export default component.exports